/**
 * Validation
 */

import {validationRules} from "./validation-rules";

const validation = (() => {

    let _o = {
        inputs: null,
        recaptcha: null,
        selectors: {
            rules: "[data-validation-rules]",
            form: "[data-validation-form]"
        }
    };

    let status = [];

    const init = () => {
        validationRules.init();
        initEvents();
    };

    const initEvents = () => {
        const forms = document.querySelectorAll(_o.selectors.form);
        const inputs = document.querySelectorAll(_o.selectors.form + " " + _o.selectors.rules);

        forms.forEach((form) => {
            form.addEventListener("submit", submitForm);
        });

        inputs.forEach((input) => {
            input.addEventListener("change", validateInput);
            input.addEventListener("focusout", validateInput);
        });
    };

    const submitForm = () => {
        event.preventDefault();
        status = [];
        const form = event.target;
        const inputs = form.querySelectorAll(_o.selectors.rules);
        const action = form.querySelector('input[name=action]');

        let recaptcha = validateGrecaptcha();

        inputs.forEach((input) => validateInput(input));

        setTimeout(() => {
            if (!status.includes(false) && recaptcha) {

                let request = new XMLHttpRequest();
                // request.responseType = 'json';
                request.onreadystatechange = function () {
                    if (request.status >= 200 && request.status < 300) {
                        // Runs when the request is successful
                        // const jsonResponse = JSON.parse(request.responseText);
                        console.log(request.responseText);

                        formSubmitted(form);
                    } else {
                        // Runs when it's not
                        console.log(request.response);
                    }
                };
                request.open("POST", form.getAttribute("action"), true);

                const fileInput = form.querySelector("[type=file]");

                const fd = new FormData(form);

                if (fileInput) fd.append("file", fileInput.files[0]);

                let date = new Date();
                date.setTime(date.getTime()+(1000*24*60*60*1000));
                document.cookie = action.value + "=" + JSON.stringify(serializeArray(fd)) + "; path=/;expires = " + date.toGMTString();

                request.send(fd);
            }
        });
    };

    const formSubmitted = (form) => {
        form.reset();

        let formSubmitted = form.querySelector("[data-form-submitted]");

        if (formSubmitted) {
            formSubmitted.classList.add("submitted");
            formSubmitted.setAttribute("role", "alert");
            const p = formSubmitted.querySelector("p");
            const actionElems = form.querySelectorAll("input, select, label, a, button");
            p.setAttribute("tabindex", "0");
            p.focus();

            actionElems.forEach(actionEl => actionEl.setAttribute("tabindex", "-1"));

            setTimeout(function(){
                formSubmitted.classList.remove("submitted");
                actionElems.forEach(actionEl => actionEl.removeAttribute("tabindex"));
            }, 5000);

        }
    };

    const serializeArray = (formData) => {
        let pairs = {};

        // Add each name/value pair to the array
        for (const [name, value] of formData) {
            pairs[name] = value;
        }

        console.log(pairs);
        return pairs;
    }

    const validateGrecaptcha = () => {
        _o.recaptcha = document.querySelector(".g-recaptcha");

        if (!_o.recaptcha || !grecaptcha)
            return true;

        const response = grecaptcha.getResponse();

        if (!response)
            setError(_o.recaptcha, "Pole jest wymagane");

        return response;

    };

    const recaptchaCallback = (response) => {
        if (response)
            setSuccess(_o.recaptcha);
    };

    const validateInput = (input) => {
        if (input.target)
            input = input.target;

        let rules = getValidationRules(input);
        let type = input.getAttribute("type");
        let value, size = "";
        let isAnyError = false;
        let validateResponse;

        switch (type) {
            case "checkbox":
                value = input.checked;
                break;
            case "file":
                if (input.files[0]) {
                    value = input.files[0].type;
                    size = input.files[0].size;
                } else {
                    value = '';
                }
                break;
            default:
                value = input.value;
        }


        for (let i = 0; i < rules.length; i++) {
            let currentRule = validationRules.returnValidationRule(rules[i]);
            validateResponse = currentRule(value, type, size);

            if (validateResponse.error) {
                isAnyError = true;
                break;
            } else {
                isAnyError = false;
            }
        }

        //skip errors if element is not visible
        if(input.offsetParent === null)
            isAnyError = false;

        status.push(!isAnyError);

        if (isAnyError) {
            setError(input, validateResponse.msg);
        } else {
            setSuccess(input);
        }
    };

    const getValidationRules = (element) => {
        let data = element.dataset.validationRules;
        return data.split(',');
    };

    const setError = (element, msg) => {
        const container = element.parentNode;

        if (container.classList.contains("error")) {
            const alert = container.querySelector("small");
            alert.innerHTML = msg;
        } else {
            container.classList.add("error");

            let alert = document.createElement("small");
            alert.setAttribute("role", "alert");
            alert.innerHTML = msg;
            container.appendChild(alert);
        }
    };

    const setSuccess = (element) => {
        const container = element.parentNode;
        const alert = container.querySelector("small");
        if (alert)
            container.removeChild(alert);

        container.classList.remove("error");
    };

    return {
        init: init,
        recaptchaCallback: recaptchaCallback
    };
})();

export {validation}
